import { render } from "./icons-search.svg?vue&type=template&id=f9cdd5e6?inline"
const script = {}
script.render = render

export default script